import React from "react"
import "./src/styles.css"
import { Grommet } from "grommet"
import { MDXProvider } from "@mdx-js/react"
import theme from "./src/theme"
import mdxComponents from "./src/components/mdxComponents"
import "photoswipe/dist/photoswipe.css"

export const wrapRootElement = ({ element }) => (
  <Grommet theme={theme}>
    <MDXProvider components={mdxComponents}>{element}</MDXProvider>
  </Grommet>
)
